import { DeliveryProvider } from '../../../../services/exports/Constants';

export default {
  [DeliveryProvider.Standalone]: 'Flota kierowców restauracji',
  [DeliveryProvider.UberDrive]: 'Uber drive',
  [DeliveryProvider.WoltDrive]: 'Wolt drive',
};
